// extracted by mini-css-extract-plugin
export var brand = "_ar-9";
export var compact = "_ar-6";
export var extraSmall = "_ar-7";
export var icon = "_ar-0";
export var large = "_ar-4";
export var light = "_ar-1";
export var medium = "_ar-5";
export var outline = "_ar-b";
export var primaryDark = "_ar-a";
export var primaryLight = "_ar-8";
export var primaryModern = "_ar-c";
export var success = "_ar-2";
export var successSolid = "_ar-3";